<template>
  <div>
    <div style="display: flex;justify-content: space-between">
      <div>
        <el-input style="width: 300px;margin-right: 10px;" prefix-icon="el-icon-search"
                  v-model="reachCircle.title"
                  @keydown.enter.native="initCircles"
                  placeholder="请输入圈子名称进行搜索" clearable @clear="initCircles"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="initCircles">搜索</el-button>
      </div>
      <!--      <div>
              <el-upload style="display: inline-flex;margin-right: 10px;"
                         :headers="headers"
                         :show-file-list="false"
                         :on-success="onSuccess"
                         :on-error="onError"
                         :disabled="importDataDisabled"
                         :before-upload="beforeUpload"
                         accept=".xls"
                         action="/api/user/import">
                <el-button type="success" :icon="importDataBtnIcon" :disabled="importDataDisabled">{{
                    importDataText
                  }}
                </el-button>
              </el-upload>
              <el-button type="success" icon="el-icon-download" @click="exportData">导出数据</el-button>
              <el-button type="primary" icon="el-icon-plus" @click="showAddUserView">添加用户</el-button>
            </div>-->
    </div>
    <div style="margin-top: 30px;">
      <el-table
          v-loading="circleLoading"
          :data="circles"
          border
          style="width: 100%">
        <!--        <el-table-column-->
        <!--            fixed-->
        <!--            type="selection"-->
        <!--            width="40">-->
        <!--        </el-table-column>-->
        <el-table-column
            label="创建人" width="150">
          <template slot-scope="scope">
            <el-link type="primary" @click="getUserInfo(scope.row.userId)">{{ scope.row.nickname }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
            label="头像" width="60">
          <template slot-scope="scope">
            <div class="demo-type">
              <div>
                <el-avatar :src="scope.row.icon" shape="square"></el-avatar>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="title"
            label="名称"
            width="200">
        </el-table-column>
        <el-table-column
            prop="introductory"
            label="简介"
            width="260">
        </el-table-column>
        <el-table-column
            prop="date"
            label="创建日期"
            width="150">
        </el-table-column>
        <el-table-column
            label="类别"
            width="150">
          <template slot-scope="scope">
            <el-select @change="enabledChange(scope.row)" v-model="scope.row.type">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
            label="动态"
            width="100">
          <template slot-scope="scope">
            <el-link type="primary" @click="showCircleDynamic(scope.row.id)">动态</el-link>
          </template>
        </el-table-column>
        <el-table-column
            label="状态"
            width="200">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.enabled"
                @change="enabledChange(scope.row)"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                active-text="启用"
                inactive-text="禁用">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
            prop="remark"
            label="备注"
            width="150">
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="200">
          <template slot-scope="scope">
            <el-button @click="showEditCircle(scope.row)">编辑</el-button>
            <el-button type="danger" @click="deleteCircle(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:10px;display: flex;justify-content: space-between">
        <el-pagination
            background
            @current-change="currentChange"
            @size-change="sizeChange"
            layout="sizes,prev, pager, next, jumper, ->, total"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
        :title="title"
        :visible.sync="editDialogVisible"
        width="30%" style="min-width: 350px">
      <div>
        <el-form ref="editCircleForm" :model="circle" :rules="editRules">
          <el-form-item label="圈子头像" prop="icon">
            <div class="demo-type">
              <div>
                <el-avatar :src="circle.icon" shape="square"></el-avatar>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="圈子名称" prop="title">
            <el-input style="width: 270px" v-model="circle.title"
                      placeholder="请输入圈子名称"></el-input>
          </el-form-item>
          <el-form-item label="圈子简介" prop="introductory">
            <el-input type="textarea" style="width: 300px" v-model="circle.introductory"></el-input>
          </el-form-item>
          <el-form-item label="圈子类别" prop="type">
            <el-select style="width: 270px" v-model="circle.type">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状  态" prop="enabled">
            <el-switch
                v-model="circle.enabled"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                active-text="启用"
                inactive-text="禁用">
            </el-switch>
          </el-form-item>
          <el-form-item label="圈子备注" prop="remark">
            <el-input type="textarea" style="width: 300px" v-model="circle.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="editDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="doEditCircle">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
        :visible.sync="userDialogVisible"
        width="50%" style="min-width: 350px">
      <div v-if="userInfoLoading">
        <el-descriptions :colon="false">
          <el-descriptions-item :colon="false">
            <el-avatar :size="70" :src="userInfo.avatarUrl"></el-avatar>
          </el-descriptions-item>
<!--          <el-descriptions-item label="用户名:">{{ userInfo.username }}</el-descriptions-item>-->
          <el-descriptions-item label="昵称:">{{ userInfo.nickname }}</el-descriptions-item>
          <el-descriptions-item label="学校:">
            <el-tag size="small">{{ userInfo.schoolName }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="认证信息:">
            {{ userInfo.intro }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="userDialogVisible = false">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog width="700px" :visible.sync="outerVisible">
      <div class="infinite-list-wrapper" style="overflow:auto">
        <ul v-infinite-scroll="getCircleDynamicList"
            infinite-scroll-disabled="disabled">
          <div v-for="(dynamic, index) in this.dynamicList" :key="index">
            <el-container style="padding-right:30px;">
              <el-header height="40" style="text-align: left;padding-top: 10px;">
                <el-row>
                  <el-col :span="2">
                    <!-- 头像-->
                    <div class="avatar-border">
                      <el-avatar v-if="dynamic.anonymity===0" :src="dynamic.avatarUrl"></el-avatar>
                      <el-avatar v-if="dynamic.anonymity===1" icon="el-icon-user-solid"></el-avatar>
                      <div v-if="dynamic.anonymity===0">
                        <div v-if="dynamic.utype===2"
                             class="badge-gender" style="background-color:#FF6E40;">v
                        </div>
                        <div v-if="dynamic.utype===1"
                             class="badge-gender" style="background-color:#3688FF; ">v
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <!--昵称 时间 学校-->
                    <div style="display: flow">
                      <div class="title-info">
                        {{ dynamic.nickname }}
                        <span v-if="dynamic.stick===1"
                              style="color:#EF5350;padding-left: 5px;">
                        [置顶]
                      </span>
                        <div style="font-size: 13px; ">
                          <div style="float: left;">
                            {{ dynamic.transformDate }}
                          </div>
                          <div style="color: #42A5F5; float: left; padding-left: 5px;">
                            {{ dynamic.schoolName }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-header>
              <el-main style="text-align: left;padding-top: 10px;padding-bottom: 10px;">
                <div @click="dynamicDetail(dynamic.id)">
                  <span v-if="dynamic.type!==1" style="word-break:break-word;" v-html='dynamic.content'></span>
                  <div v-if="dynamic.type===1">
                    发布了文章
                    <div style="background-color: #EEEEEE;border-radius: 2px;padding: 5px;overflow: hidden;text-overflow:ellipsis;
            white-space: nowrap;">
                      <i class="el-icon-link el-icon--left"
                         style="border-right: #8a8f97 solid 2px;padding-right: 5px"></i>
                      <span style="font-size: 13px;">
                    {{ JSON.parse(dynamic.content)[JSON.parse(dynamic.content).length - 1].content }}
                  </span>
                    </div>
                  </div>
                  <div v-if="dynamic.dynamicImgList.length>0 && dynamic.type===0" style="padding-top: 10px;">
                    <div v-if="dynamic.dynamicImgList.length!==4" style="width: 500px;display: inline;padding-left:5px;"
                         v-for="(img, indexImg) in dynamic.dynamicImgList" :key="indexImg">
                      <el-image
                          style="width: 150px; height: 150px"
                          :fit="cover"
                          :src="img.imgUrl"
                          :preview-src-list="imgList(dynamic.dynamicImgList)">
                      </el-image>
                    </div>
                    <div v-if="dynamic.dynamicImgList.length===4 && dynamic.type===0"
                         style="width: 500px;display: inline;padding-left:5px;"
                         v-for="(img, indexImg) in dynamic.dynamicImgList" :key="indexImg">
                      <el-image
                          style="width: 160px; height: 160px"
                          fit="cover"
                          :src="img.imgUrl"
                          :preview-src-list="imgList(dynamic.dynamicImgList)">
                      </el-image>
                    </div>
                  </div>
                  <div v-if="dynamic.dynamicImgList.length>0 && dynamic.type===2">
                    <Video v-bind:videoUrl="dynamic.dynamicImgList[0].imgUrl" :status="true"></Video>
                  </div>
                  <div v-if="dynamic.type===3" style="color: #E6A23C;">
                    投票内容请在移动端查看
                  </div>
                  <!-- 圈子标签 -->
                  <div style="padding-top: 10px;padding-bottom: 10px;" v-if="dynamic.circleType!==0">
                    <!-- <gui-tags text="#边框标签" bgClass="gui-bg-white" color="#f75f00"
                        :width="0" :lineHeight="1.5" :size="28" :borderRadius="50" borderColor="#FF0035"></gui-tags> -->
                    <div v-if="dynamic.circles!==null"
                         style="float: left;display:initial;height: 20px; border: #2196F3 solid 1px; font-size: 13px;color:#2196F3 ; border-radius: 50px;padding-left: 7px;padding-right: 7px;">
                      {{ dynamic.circles.title }}
                    </div>
                  </div>
                </div>
              </el-main>
              <el-footer height="50"
                         style="text-align: center;padding-top: 5px;padding-bottom: 5px; border-top:solid #F6F7F8 2px;">
                <el-row>
                  <el-col :span="8">
                    {{ dynamic.praiseCount }} 赞
                  </el-col>
                  <el-col :span="8">{{ dynamic.commentCount }} 评论</el-col>

                </el-row>
              </el-footer>
            </el-container>
            <div class="line"></div>
          </div>
        </ul>
        <p v-if="loading">加载中...</p>
        <p v-if="empty">没有更多了</p>
      </div>

      <el-dialog
          v-loading="dynamicLoading"
          :visible.sync="innerVisible"
          width="600px" style="min-width: 350px"
          append-to-body>
        <div v-if="innerVisible">

          <el-container style="padding-right:30px;margin-left: 44px">
            <el-header height="40" style="text-align: left;padding-top: 10px;">
              <el-row>
                <el-col :span="2">
                  <!-- 头像-->
                  <div class="avatar-border">
                    <el-avatar v-if="dynamic.anonymity===0" :src="dynamic.avatarUrl"></el-avatar>
                    <el-avatar v-if="dynamic.anonymity===1" icon="el-icon-user-solid"></el-avatar>
                    <div v-if="dynamic.anonymity===0">
                      <div v-if="dynamic.utype===2"
                           class="badge-gender" style="background-color:#FF6E40;">v
                      </div>
                      <div v-if="dynamic.utype===1"
                           class="badge-gender" style="background-color:#3688FF; ">v
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <!--昵称 时间 学校-->
                  <div style="display: flow">
                    <div class="title-info">
                      {{ dynamic.nickname }}
                      <span v-if="dynamic.stick===1"
                            style="color:#EF5350;padding-left: 5px;">
                        [置顶]
                      </span>
                      <div style="font-size: 13px; ">
                        <div style="float: left;">
                          {{ dynamic.transformDate }}
                        </div>
                        <div style="color: #42A5F5; float: left; padding-left: 5px;">
                          {{ dynamic.schoolName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-header>
            <el-main style="text-align: left;padding-top: 10px;padding-bottom: 10px;">
              <span v-if="dynamic.type!==1" style="word-break:break-word;" v-html='dynamic.content'></span>
              <div v-if="dynamic.type===1">
                <span>{{ JSON.parse(dynamic.content)[JSON.parse(dynamic.content).length - 1].content }}</span>
                <span style="word-break:break-word;" v-html='jsonToHtml(dynamic.content)'></span>
              </div>
              <div v-if="dynamic.dynamicImgList.length>0 && dynamic.type===0" style="padding-top: 10px;">
                <div v-if="dynamic.dynamicImgList.length!==4" style="width: 500px;display: inline;padding-left:5px;"
                     v-for="(img, indexImg) in dynamic.dynamicImgList" :key="indexImg">
                  <el-image
                      style="width: 150px; height: 150px"
                      fit="cover"
                      :src="img.imgUrl"
                      :preview-src-list="imgList(dynamic.dynamicImgList)">
                  </el-image>
                </div>
                <div v-if="dynamic.dynamicImgList.length===4 && dynamic.type===0"
                     style="width: 500px;display: inline;padding-left:5px;"
                     v-for="(img, indexImg) in dynamic.dynamicImgList" :key="indexImg">
                  <el-image
                      style="width: 160px; height: 160px"
                      fit="cover"
                      :src="img.imgUrl"
                      :preview-src-list="imgList(dynamic.dynamicImgList)">
                  </el-image>
                </div>
              </div>
              <div v-if="dynamic.dynamicImgList.length>0 && dynamic.type===2">
                <Video v-bind:videoUrl="dynamic.dynamicImgList[0].imgUrl" :status="true"></Video>
              </div>
              <div v-if="dynamic.type===3" style="color: #E6A23C;">
                投票内容请在移动端查看
              </div>
              <!-- 圈子标签 -->
              <div style="padding-top: 10px;padding-bottom: 10px;" v-if="dynamic.circleType!==0">
                <!-- <gui-tags text="#边框标签" bgClass="gui-bg-white" color="#f75f00"
                    :width="0" :lineHeight="1.5" :size="28" :borderRadius="50" borderColor="#FF0035"></gui-tags> -->
                <div v-if="dynamic.circles!==null"
                     style="float: left;display:initial;height: 20px; border: #2196F3 solid 1px; font-size: 13px;color:#2196F3 ; border-radius: 50px;padding-left: 7px;padding-right: 7px;">
                  {{ dynamic.circles.title }}
                </div>
              </div>
            </el-main>
            <el-footer height="50"
                       style="text-align: center;padding-top: 5px;padding-bottom: 5px; border-top:solid #F6F7F8 2px;">
              <el-row>
                <el-col :span="8">
                  {{ dynamic.praiseCount }} 赞
                </el-col>
                <el-col :span="8">{{ dynamic.commentCount }} 评论</el-col>
                <el-col :span="8">

                </el-col>
              </el-row>
            </el-footer>
          </el-container>
          <div class="line"></div>
          <div style=" border-bottom: #409EFF solid 2px; padding-top: 10px;width: 30px">
            评论
          </div>
          <comment-list :dynamic-id="dynamicId" :is-delete="false"></comment-list>
        </div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="innerVisible = false">取 消</el-button>
  </span>
      </el-dialog>
      <div style="padding-top: 10px;padding-bottom: 10px;">
        共有{{dynamicTotal}}条动态
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outerVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Video from "../../../components/preview/VideoPreview";
import commentList from "../../../components/commentList/commentList";
export default {
  name: 'CirclesList',
  data() {
    return {
      options: [{
        value: 1,
        label: '热门'
      }, {
        value: 2,
        label: '学习'
      }, {
        value: 3,
        label: '校园'
      }, {
        value: 4,
        label: '情感'
      }, {
        value: 5,
        label: '娱乐'
      }, {
        value: 6,
        label: '限定'
      }, {
        value: 7,
        label: '其他'
      }],
      circles: [],
      circleLoading: false,
      total: 0,
      currentPage: 1,
      size: 10,
      reachCircle: {
        title: ''
      },
      userDialogVisible: false,
      editDialogVisible: false,
      userInfoLoading: false,
      userInfo: null,
      title: '',
      circle: {
        icon: '',
        title: '',
        type: '',
        introductory: '',
        enabled: 1,
        remark: ''
      },
      editRules: {
        title: [{
          required: true,
          message: '请输入圈子名称',
          trigger: blur
        }
        ],
        introductory: [{
          required: true,
          message: '请输入圈子简介',
          trigger: blur
        }
        ]
      },
      outerVisible: false,
      innerVisible: false,

      dynamicList: [],
      dynamicCurrentPage: 1,
      dynamicSize: 10,
      loading: false,
      empty: false,
      apiLoading: false,
      count: 10,
      DialogVisible: false,
      dynamic: null,
      dynamicLoading: false,
      dynamicTotal: 0,
      circleId: '',
      dynamicId:0
    }
  },
  components: {
    Video,
    commentList
  },
  computed: {
    noMore() {
      return this.empty
      //return this.count >= 20
    },
    disabled() {
      console.log(this.loading || this.noMore)
      return this.loading || this.noMore
      //return this.loading || this.empty
    }
  },
  mounted() {
    this.initCircles()
  },
  methods: {
    doEditCircle() {
      this.$refs['editCircleForm'].validate(valid => {
        if (valid) {
          this.putRequest('/circles/web/', this.circle).then(resp => {
            if (resp) {
              this.editDialogVisible = false
              this.initCircles()
            }
          })
        } else {
          this.$message('标*字段不能为空')
        }
      })
    },
    deleteCircle(circle) {
      this.$confirm('此操作将永久删除【' + circle.title + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest('/circles/web/' + circle.id).then(resp => {
          if (resp) {
            this.initCircles()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    enabledChange(circle) {
      this.putRequest('/circles/web/', circle).then(resp => {
        if (resp) {
          this.initCircles()
        }
      })
    },
    showEditCircle(data) {
      this.title = '编辑圈子信息'
      this.editDialogVisible = true
      this.circle = data

    },
    sizeChange(size) {
      this.size = size
      this.initCircles()
    },
    currentChange(currentPage) {
      this.currentPage = currentPage
      this.initCircles()
    },
    initCircles() {
      this.circleLoading = true
      this.postRequest('/circles/web/circlesList?currentPage=' + this.currentPage + '&size=' + this.size, this.reachCircle).then(resp => {
        this.circleLoading = false
        if (resp) {
          this.circles = resp.data
          this.total = resp.total
        }
      })
    },
    getUserInfo(userId) {
      this.userDialogVisible = true
      this.postRequest('/circles/web/userInfo?id=' + userId).then(resp => {
        if (resp) {
          this.userInfo = resp
        }
        this.userInfoLoading = true
      })
    },


    //dynamic
    videoUrl(url) {
      let file;
      file = {
        url: url
      }
      console.log(file)
      return file
    },
    imgList(imgList) {
      var imgs = []
      for (var i = 0; i < imgList.length; i++) {
        imgs[i] = imgList[i].imgUrl
      }
      return imgs
    },
    showCircleDynamic(id) {
      this.circleId = id
      this.dynamicList = []
      this.dynamicTotal = 0
      this.dynamicCurrentPage = 1
      this.dynamicSize = 10
      this.empty = false
      this.outerVisible = true
      this.getCircleDynamicList()
    },
    getCircleDynamicList: function () {
      this.outerVisible = true
      var dynamic = []
      if (this.empty === false) {
        this.loading = true
        this.postRequest('/dynamic/app/circle?currentPage=' + this.dynamicCurrentPage + '&size=' + this.dynamicSize + '&circleId=' + this.circleId)
            .then(
                resp => {
                  this.loading = false
                  if (resp) {
                    dynamic = resp.data
                    // if (dynamic.length > 0) {
                    //   dynamic.forEach(data => {
                    //     if (data.type === 1) {
                    //       data.content = this.jsonToHtml(data.content)
                    //     }
                    //   })
                    // }
                    this.dynamicList = this.dynamicList.concat(dynamic);
                    this.dynamicTotal = resp.total
                    this.DynamicCurrentPage++;
                    if (resp.data.length === 0) {
                      this.empty = true
                    }
                  }
                })
      }
    },
    jsonToHtml(content) {
      content = JSON.parse(content)
      console.log(content[1].content)
      var html = ''
      if (content.length > 0)
        content.forEach(item => {
          switch (item.type) {
            case "h3":
              html = html.concat('<h3>' + item.content + '</h3>')
              break;
            case "text":
              html = html.concat('<p>' + item.content + '</p>')
              break;

            case "txt":
              html = html.concat('<p>' + item.content + '</p>')
              break;
            case "code":
              html = html.concat('<pre>' + item.content + '</pre>')
              break;
            case "center":
              html = html.concat('<div style="text-align: center;">' + item.content + '</div>')
              break;
            case "quote":
              html = html.concat('<blockquote>' + item.content + '</blockquote>')
              break;
            case "strong":
              html = html.concat('<strong>' + item.content + '</strong>')
              break;
            case "link":
              html = html.concat('<p><a href="\'' + item.content + '" target="_blank">' + item['content'] + '</a><p>')
              break;
            case "spline":
              html = html.concat('<p><hr /><p>')
              break;
            case "img":
              html = html.concat('<img src=' + '"' + item.content + '" style="width:400px;"/>')
              break;
          }
        })
      return html
    },
    dynamicDetail(id) {
      this.innerVisible = true
      this.dynamic = null
      this.dynamicLoading = true
      this.dynamicId = id
      this.postRequest('/dynamic/app/detail?id=' + id)
          .then(
              resp => {
                this.isLoad = true
                if (resp) {
                  //console.log(resp)
                  this.dynamicLoading = false
                  this.dynamic = resp
                  // this.dynamic.content = this.jsonToHtml(resp.content)
                }
              })
    },
  }
}
</script>

<style scoped>
.infinite-list-wrapper {
  width: 600px;
  height: 700px;
  /*border: 1px solid #eee;*/
}

.avatar-border {
  width: 60px;
}

.title-info {
  /*width: 400px;*/
  text-align: left;
  word-break: break-word;
  padding-left: 5px;
}

/* 分割线 */
.line {
  height: 10px;
  background-color: #F6F7F8;
}

/* 徽章 */
.badge-gender {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  text-align: center;
  font-size: 15px;
  line-height: 15px;
  position: absolute;
  left: 25px;
  top: 23px;
  z-index: 1;
  border: #FFFFFF solid 2px;
  color: #FFFFFF;
}
</style>
